<template>
  <div class="card-content">
    <article class="media">
      <figure class="media-left">
        <logo readOnly
              :elementId="bailleur.id"
              :libelleElement="$t('detailBailleur.libelleForLogo',
              { nomCommercial: bailleur.nomCommercial })"></logo>
      </figure>
      <div class="media-content">
        <div class="content">
          <span class="has-text-default">N° {{bailleur.code}}</span>
          <b-field class="is-marginless">
            <div class="mgr-10px" v-if="bailleur.civiliteId && civilite">
              {{ civilite.libelle }}
            </div>
            <div class="title is-4 is-marginless" v-if="!isParticulier">
              {{ bailleur.nomCommercial }}
            </div>
            <div class="title is-4 is-marginless" v-else>
              {{ bailleur.prenom }} {{ bailleur.nom }}
            </div>
          </b-field>
          <span class="has-text-default is-italic"
                v-if="afficherInformationAdministrativeSousTypeAdresse"> {{ getSousType }}</span>
          <br v-if="afficherInformationAdministrativeSousTypeAdresse">
          <span
            class="has-text-default is-italic"
            v-if="bailleur.estMairie && isCollectivite">
            {{ $t('detailBailleur.informationsGenerales.estMairie')}}
          </span>
        </div>
      </div>
    </article>
    <div class="columns">
      <div class="column"
        :class="isParticulier ? 'is-3' : 'is-4'">
        <p class="has-text-weight-bold">
          {{ $t('detailBailleur.informationsGenerales.coordonees')}}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.email')}}</p>
        <p class="lien has-text-weight-semibold">{{bailleur.email}}</p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.telFixe')}}</p>
        <p class="has-text-weight-semibold">{{bailleur.telephone}}</p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.telPortable')}}</p>
        <p class="has-text-weight-semibold">{{bailleur.portable}}</p>
      </div>
      <div class="column is-4" v-if="isCollectivite">
        <p class="has-text-weight-bold">
          {{ $t('detailBailleur.informationsGenerales.infoAdministrative')}}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailFournisseurSupport.informationsGenerales.interne')}}
        </p>
        <p class="has-text-weight-semibold">
          {{ bailleur.interne ? $t('general.oui') : $t('general.non') }}
        </p>
      </div>
      <div class="column is-4" v-if="afficherInformationAdministrativeSousTypeAdresse
      && !isParticulier">
        <p class="has-text-weight-bold">
          {{ $t('detailBailleur.informationsGenerales.infoAdministrative')}}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.applicationTva')}}</p>
        <p class="has-text-weight-semibold">
          {{ getApplicationTvaTrad(bailleur.applicationTva) }}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.siret')}}</p>
        <p class="has-text-weight-semibold">
        {{ bailleur.siret }}
        </p>
      </div>
      <div class="column"
        :class="isParticulier ? 'is-3' : 'is-4'">
        <p class="has-text-weight-bold">
          {{ afficherInformationAdministrativeSousTypeAdresse
          ? $t('detailBailleur.informationsGenerales.adresses')
          : $t('detailBailleur.informationsGenerales.adresse')}}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{ $t('detailBailleur.informationsGenerales.adressePostale')}}</p>
        <p class="has-text-weight-semibold">
          {{bailleur.adressePostale.intitule1}}
          {{bailleur.adressePostale.intitule2}}
          {{bailleur.adressePostale.intitule3}}
          <br v-if="bailleur.adressePostale.intitule1">
          {{bailleur.adressePostale.adresse1}}
          {{bailleur.adressePostale.adresse2}}
          {{bailleur.adressePostale.adresse3}}
          <br v-if="bailleur.adressePostale.adresse1">
          {{bailleur.adressePostale.codePostal}}
          {{bailleur.adressePostale.ville}}
          {{bailleur.adressePostale.pays}}
        </p>
        <div v-if="afficherInformationAdministrativeSousTypeAdresse">
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.adressePaiement')}}</p>
        <p class="has-text-weight-semibold"
           v-if="bailleur.adresseFacturationDifferente">
          {{bailleur.adresseFacturation.intitule1}}
          {{bailleur.adresseFacturation.intitule2}}
          {{bailleur.adresseFacturation.intitule3}}
          <br v-if="bailleur.adresseFacturation.intitule1">
          {{bailleur.adresseFacturation.adresse1}}
          {{bailleur.adresseFacturation.adresse2}}
          {{bailleur.adresseFacturation.adresse3}}
          <br v-if="bailleur.adresseFacturation.adresse1">
          {{bailleur.adresseFacturation.codePostal}}
          {{bailleur.adresseFacturation.ville}}
          {{bailleur.adresseFacturation.pays}}
        </p>
        <p class="has-text-weight-semibold"
           v-else>
          {{bailleur.adressePostale.intitule1}}
          {{bailleur.adressePostale.intitule2}}
          {{bailleur.adressePostale.intitule3}}
          <br v-if="bailleur.adressePostale.intitule1">
          {{bailleur.adressePostale.adresse1}}
          {{bailleur.adressePostale.adresse2}}
          {{bailleur.adressePostale.adresse3}}
          <br v-if="bailleur.adressePostale.adresse1">
          {{bailleur.adressePostale.codePostal}}
          {{bailleur.adressePostale.ville}}
          {{bailleur.adressePostale.pays}}
        </p>
        </div>
      </div>
      <div class="column is-3" v-if="isParticulier">
        <p class="has-text-weight-bold">
          {{ $t('detailBailleur.informationsGenerales.infoAdministrative')}}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.applicationTva')}}</p>
        <p class="has-text-weight-semibold">
          {{ getApplicationTvaTrad(bailleur.applicationTva) }}
        </p>
      </div>
      <div class="column is-3" v-if="isParticulier">
        <p class="has-text-weight-bold">
          {{ $t('detailBailleur.informationsGenerales.infoComplementaire')}}
        </p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.dateNaissance')}}</p>
        <p class="has-text-weight-semibold">{{bailleur.dateNaissance | formatDate}}</p>
        <p class="has-text-default is-italic mgt-20px">
          {{$t('detailBailleur.informationsGenerales.nomJeuneFille')}}</p>
        <p class="has-text-weight-semibold"> {{ bailleur.nomJeuneFille }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import Logo from '@/components/general/Logo';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import {
  LISTE_SOUS_TYPE,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_CONFRERE,
  TIERS_SOUS_TYPE_AFFICHEUR,
  TIERS_SOUS_TYPE_TECHNICIEN,
  TIERS_SOUS_TYPE_COLLECTIVITE,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  LISTE_APPLICATION_TVA,
} from '@/configuration/tiers/tiersConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    bailleur: {
      type: Object,
      required: true,
    },
    afficherInformationAdministrativeSousTypeAdresse: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    Logo,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getSousType() {
      let sousTypeLibelle = '';
      this.bailleur.sousTypes.forEach((sousType) => {
        if (sousTypeLibelle) sousTypeLibelle += ', ';
        sousTypeLibelle += this.$i18n.t(LISTE_SOUS_TYPE.find((sousTypeListe) => {
          return sousTypeListe.code === sousType;
        }).libelle);
      });
      return sousTypeLibelle;
    },
    isParticulier() {
      return this.bailleur.sousTypes.find((sousType) => {
        return sousType === TIERS_SOUS_TYPE_BAILLEUR_PRIVE;
      });
    },
    isCollectivite() {
      return this.bailleur.sousTypes.find((sousType) => {
        return sousType === TIERS_SOUS_TYPE_COLLECTIVITE;
      });
    },
    civilite() {
      return this.parametre(PARAMETRES_KEYS.civilite).find((civilite) => {
        return this.bailleur.civiliteId === civilite.id;
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ordonnanceSousType() {
      if (this.bailleur.sousTypes.find((sousType) => {
        return sousType === TIERS_SOUS_TYPE_COLLECTIVITE;
      })) return;
      const sousTypes = [];
      if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_BAILLEUR_PRIVE === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_BAILLEUR_PRIVE);
      else if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_BAILLEUR_PRO === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_BAILLEUR_PRO);
      else if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_BAILLEUR_CONCESSION === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_BAILLEUR_CONCESSION);
      if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_AFFICHEUR === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_AFFICHEUR);
      if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_TECHNICIEN === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_TECHNICIEN);
      if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_CONFRERE === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_CONFRERE);
      if (this.bailleur.sousTypes.find((sousType) => {
        return TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE === sousType;
      })) sousTypes.push(TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE);
      this.bailleur.sousTypes = sousTypes;
    },
    getApplicationTvaTrad(value) {
      const find = LISTE_APPLICATION_TVA.find((app) => app.code === value);
      return find ? this.$t(find.libelle) : '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.civilite]);
      this.ordonnanceSousType();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
